import { fastApi } from "@/redux/api/fastApi";

export const calendarApi = fastApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllEvents: builder.query({
      query: ({ filter, productId }) => ({
        url: `/events/all?filter=${filter}&product_id=${productId}`,
        method: "GET",
      }),
    }),

    getTopEvents: builder.query({
      query: ({ productId }) => ({
        url: `/events/top?product_id=${productId}`,
        method: "GET",
      }),
    }),

    getPastWeekEvents: builder.query({
      query: ({ productId }) => ({
        url: `/events/week/past?product_id=${productId}`,
        method: "GET",
      }),
    }),

    getThisWeekEvents: builder.query({
      query: ({ productId }) => ({
        url: `/events/week/this?product_id=${productId}`,
        method: "GET",
      }),
    }),

    getNextWeekEvents: builder.query({
      query: ({ productId }) => ({
        url: `/events/week/next?product_id=${productId}`,
        method: "GET",
      }),
    }),

    getEventVideos: builder.query({
      query: ({ event, productId }: { event: string; productId: string }) => ({
        url: `/videos/${encodeURIComponent(
          event
        )}?product_id=${encodeURIComponent(productId)}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAllEventsQuery,
  useGetTopEventsQuery,
  useGetPastWeekEventsQuery,
  useGetThisWeekEventsQuery,
  useGetNextWeekEventsQuery,
  useGetEventVideosQuery,
} = calendarApi;
